import { Component, Input } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { Router } from '@angular/router';
import { SessionService } from '../common/session/session.service';
import { TranslateService } from '@ngx-translate/core';
import { CatalogueService } from '../catalogue/catalogue.service';
import { AnalyticsService } from '../analytics/analytics.service';

@Component({
  selector: 'app-detail-product',
  templateUrl: './detail-product.component.html',
  styleUrls: ['./detail-product.component.css']
})
export class DetailProductComponent {

  @Input() products: any[] = [];
  @Input() exhibitorId: string;
  @Input() catalogueId: string;
  @Input() type: string;
  @Input() title: string | undefined;

  eventName: string;
  catalogueProperties: any = {};

  constructor(public utilsService:UtilsService, private router:Router, private sessionService: SessionService, public translateService: TranslateService, 
    private catalogueService:CatalogueService, private analyticsService: AnalyticsService){

  }

  
  ngOnInit() {
    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    
    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });

    this.eventName = eventData['eventName'];
  }

  setImage(url: string): string {
    return url ? url : this.catalogueProperties.defaultProductImage || 'assets/img/no_image_available.png';
  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }

  goDetails(item) {
    const queryParams = { lang: this.utilsService.mapLanguageCode(this.translateService.currentLang) };
    this.analyticsService.sendSelectItem(item, 'product', 'detail');
    //this.router.navigate([`${this.catalogueId}/${this.exhibitorId}/${'product'}/${item.id}/detail`]);
    this.router.navigate([`${this.eventName}/${'product'}/${item.id}/detail`], {queryParams});

  }
}
